import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import AhaModuleDialog from "./AhaModuleDialog";

const LINE = "var(--color-hairline-cloud)";

function InactivePill() {
  return (
    <Box component="span" sx={{ px: "8px", py: "2px", borderRadius: "999px", fontSize: 11.5, fontWeight: 700, color: "var(--color-ink-3)", bgcolor: "var(--color-surface-press-light)" }}>
      Inactive
    </Box>
  );
}

/** Modules are shared across products; a product links to the ones it uses in its own Edit dialog. */
export default function AhaModulesPanel({ modules, environment, onChanged }) {
  const [dialog, setDialog] = useState(null);

  const saved = () => { setDialog(null); onChanged(); };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: "12px" }}>
        <Typography sx={{ fontSize: 13.5, color: "var(--color-ink-2)", maxWidth: 640 }}>
          Modules are shared by products and referenced by key from classes and sessions, so keys never change and modules are
          deactivated rather than deleted.
        </Typography>
        <Button variant="contained" disableElevation onClick={() => setDialog({ mode: "create" })}>Add module</Button>
      </Box>
      <Box role="list" aria-label="AHA modules" sx={{ border: `1px solid ${LINE}`, borderRadius: "12px", overflow: "hidden" }}>
        {modules.map((m) => (
          <Box key={m.key} role="listitem" data-testid={`aha-module-${m.key}`}
            sx={{ display: "grid", gridTemplateColumns: "minmax(0,1.6fr) 130px 150px auto", gap: "12px", alignItems: "center", p: "12px 16px", borderTop: `1px solid ${LINE}`, "&:first-of-type": { borderTop: 0 } }}>
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{m.name}</Typography>
              <Typography sx={{ fontSize: 12, color: "var(--color-ink-3)" }}>{m.key}</Typography>
            </Box>
            <Box sx={{ fontSize: 13, fontFamily: "var(--font-mono)" }}>
              {m.moduleId ? m.moduleId : <Box component="span" sx={{ color: "var(--color-ink-3)", fontFamily: "inherit" }}>No ID in {environment}</Box>}
            </Box>
            <Box sx={{ fontSize: 12.5, color: "var(--color-ink-3)" }}>
              {m.inUse > 0 ? `Used by ${m.inUse}` : "Not used"} {!m.active && <InactivePill />}
            </Box>
            <Box sx={{ textAlign: "right" }}>
              <Button size="small" variant="outlined" aria-label={`Edit ${m.name}`} onClick={() => setDialog({ mode: "edit", module: m })}>Edit</Button>
            </Box>
          </Box>
        ))}
      </Box>
      <AhaModuleDialog open={!!dialog} mode={dialog?.mode} module={dialog?.module} environment={environment}
        onSaved={saved} onClose={() => setDialog(null)} />
    </Box>
  );
}
